import httpManager from "@/app/shared/utils/httpManager";

export async function removeAgentFromQueue(queueId, agentId) {
  const url = `/queues/${queueId}/agents/${agentId}/`;
  const response = await httpManager.delete(url);
  return response.data;
}
